
    <ng-template #cardContainer>
    </ng-template>
